import { render, staticRenderFns } from "./Pos_debt_balance_detail.vue?vue&type=template&id=affa1370&scoped=true&"
import script from "./Pos_debt_balance_detail.vue?vue&type=script&lang=js&"
export * from "./Pos_debt_balance_detail.vue?vue&type=script&lang=js&"
import style0 from "./Pos_debt_balance_detail.vue?vue&type=style&index=0&id=affa1370&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "affa1370",
  null
  
)

export default component.exports